// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__pJkIp","content":"Settings_content__PBKZ7","loading":"Settings_loading__uKXra"};